export default {"src":"/_next/static/media/favorites-filled.657b63a6.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};